"use strict";
/* eslint-disable react/button-has-type */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faSpinnerThird_1 = require("@fortawesome/pro-regular-svg-icons/faSpinnerThird");
const analyticsUtils_1 = require("../../utils/analyticsUtils");
const testUtils_1 = require("../../utils/testUtils");
const constants_1 = require("../../utils/constants");
const Link_1 = __importDefault(require("../Link"));
const ConditionalWrapper_1 = __importDefault(require("../ConditionalWrapper"));
const withSpacing_1 = __importDefault(require("../../hoc/withSpacing/withSpacing"));
const styles = require('./Button.module.scss');
const loadingIcon = react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { spin: true, icon: faSpinnerThird_1.faSpinnerThird, className: styles.loadingIcon });
const Button = (_a, ref) => {
    var { appearance = 'solid', children, className = '', classNameForText = '', color = '', disabled, fluid, href, hrefTargetBlank, icon, iconPosition = 'left', isIconVisible = true, isLoading, isTextVisible = true, noDropShadow = false, noHover = false, onClick, typeIdOptions, trackingAttributes, type, LinkComponent = Link_1.default } = _a, rest = __rest(_a, ["appearance", "children", "className", "classNameForText", "color", "disabled", "fluid", "href", "hrefTargetBlank", "icon", "iconPosition", "isIconVisible", "isLoading", "isTextVisible", "noDropShadow", "noHover", "onClick", "typeIdOptions", "trackingAttributes", "type", "LinkComponent"]);
    const classNames = (0, classnames_1.default)(styles.button, {
        [styles.fluid]: !!fluid,
        [styles.solid]: appearance === 'solid',
        [styles.outline]: appearance === 'outline',
        [styles.displayAsLink]: appearance === 'link',
        [styles.black]: color === 'black',
        [styles.blue]: color === 'blue',
        [styles.green]: color === 'green',
        [styles.grey]: color === 'grey',
        [styles.lightGrey]: color === 'light-grey',
        [styles.white]: color === 'white',
        [styles.yellow]: color === 'yellow',
        [styles.lightYellow]: color === 'light-yellow',
        [styles.noDropShadow]: !!noDropShadow,
        [styles.noHover]: !!noHover,
        [className]: !!className,
    });
    const childrenContent = (childrenProp) => (react_1.default.createElement(react_1.default.Fragment, null,
        (icon || isLoading) && iconPosition === 'left' && isIconVisible && (react_1.default.createElement("span", { className: (0, classnames_1.default)(styles.icon, {
                [styles.iconLeft]: iconPosition === 'left',
                [styles.iconLeftNoText]: !isTextVisible,
            }) }, isLoading ? loadingIcon : icon)),
        react_1.default.createElement(ConditionalWrapper_1.default, { condition: !!classNameForText || (!!isIconVisible && iconPosition === 'right') || !isTextVisible, wrapper: (wrapperChildren) => (react_1.default.createElement("span", { className: (0, classnames_1.default)(classNameForText, {
                    [styles.iconRightText]: !!isIconVisible && iconPosition === 'right',
                    [styles.hideText]: !isTextVisible,
                }) }, wrapperChildren)) }, isLoading ? 'Loading' : childrenProp),
        (icon || isLoading) && iconPosition === 'right' && isIconVisible && (react_1.default.createElement("span", { className: (0, classnames_1.default)(styles.icon, {
                [styles.iconRight]: iconPosition === 'right',
                [styles.iconRightNoText]: !isTextVisible,
            }) }, isLoading ? loadingIcon : icon))));
    if (!onClick && !type && !href) {
        return (react_1.default.createElement("div", Object.assign({ className: classNames }, rest, { ref: ref }), childrenContent(children)));
    }
    return href ? (react_1.default.createElement(LinkComponent, Object.assign({ color: color, className: classNames, href: href, ref: ref }, (hrefTargetBlank && { target: '_blank' }), (0, analyticsUtils_1.getTrackingAttributes)(trackingAttributes), (0, testUtils_1.getDataTypeAttribute)(typeIdOptions), rest), childrenContent(children))) : (react_1.default.createElement("button", Object.assign({ className: classNames, disabled: disabled || isLoading, type: type || 'button', onClick: (e) => {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            if (trackingAttributes) {
                (0, analyticsUtils_1.sendGtmEvent)(constants_1.GtmEvents.ReactDataLayerPush, (0, analyticsUtils_1.getGtmEventTrackingDataAttributes)(trackingAttributes));
            }
        }, ref: ref }, (0, testUtils_1.getDataTypeAttribute)(typeIdOptions), rest), childrenContent(children)));
};
exports.default = (0, withSpacing_1.default)((0, react_1.forwardRef)(Button));
//# sourceMappingURL=Button.js.map